//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';
import 'daterangepicker';

export default {
  name: "InputDate",
  data() {
    return {
      value: this.inputInitValue ? this.inputInitValue : '',
      hasValue: false
    };
  },
  props: [ 
    'inputInitValue',
    'inputClass',
    'inputName',
    'inputDataWowAttr',
    'inputPlaceholder',
    'inputAutocomplete',
    'multiTripIndex'
  ],
  mounted(){
      let option = {
        autoApply: true,
        autoUpdateInput: false,
        firstDay: 1,
        opens: 'center',
        singleDatePicker: true
      };

      $(this.$refs.input).daterangepicker(option)
      .on('apply.daterangepicker', this.setDatePickerValue)
      .on('hide.daterangepicker', (e, picker) => {
        if(!$(e.target).val()){
          this.hasValue = false;
        }else{
          this.setDatePickerValue(e);
        }
      });

      this.$refs.input.value = this.value;
  },
  beforeDestroy() {
    $(this.$refs.input).blur();
  },
  methods: {
    clearValue(e){
      this.value = '';
      this.hasValue = false;
      this.$refs.input.value = this.value;
      this.$emit('on-update', this.inputName, '', this.multiTripIndex );
    },
    setDatePickerValue: function(e){
      const picker = $(this.$refs.input).data('daterangepicker');
      const value = picker.startDate.format('DD MMM YYYY');
      this.value = value;
      this.$refs.input.value = this.value;
      this.$emit('on-update', this.inputName, value, this.multiTripIndex);
      this.hasValue = value ? true : false;
    }
  }
  
}
